import React from "react";
import WeatherDate from "./WeatherDate";
import WeatherIcons from "./WeatherIcons";
import WeatherTemp from "./WeatherTemp";

export default function WeatherContent(props) {
  return (
    <div className="WeatherContent">
      <h1>{props.content.city}</h1>
      <br />
      <div className="row">
        <div className="col-4">
          <div className="d-flex">
            <WeatherIcons code={props.content.icon} size={50} />

            <span className="temp">
              <WeatherTemp Celsius={Math.round(props.content.temperature)} />
            </span>
          </div>
        </div>

        <div className="col-5">
          <ul>
            <li>Humidity:{props.content.humidity}%</li>
            <li>Wind: {Math.round(props.content.wind)}mph</li>
          </ul>
        </div>
        <div className="col-3">
          <div className="temp2">
            <ul>
              <li>
                {" "}
                <strong>Weather</strong>
              </li>
              <li>
                <WeatherDate date={props.content.date} />
              </li>
              <li className="text-capitalize">{props.content.description}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
